<template>
  <nav v-if="user" class="navbar navbar-light bg-white row text-black h-100">
    <div class="w-15 text-center d-flex justify-content-center">
      <div>
        <img
          src="../../../static/images/HRM_logo_2021_NT_2048x2048.png"
          width="50"
          height="50"
          class="bg-blue d-inline-block align-top rounded"
          alt=""
        />
      </div>
      <div class="d-flex flex-column justify-content-center ml-2">
        <div class="elms-title">
          {{ user.CompName }}
        </div>
        <div class="elms-title"></div>
        <div class="elms-subtitle">
          {{
            user.Lang == "EN"
              ? this.serverRouter.EngName
              : this.serverRouter.ChiName
          }}
        </div>
      </div>
    </div>
    <div class="w-65 font-weight-bold">
      <h4 class="m-0">{{ menuName }}</h4>
    </div>
    <div class="w-15">
      <div>
        <b-dropdown
          size="lg"
          variant="link"
          toggle-class="text-decoration-none"
          no-caret
        >
          <template v-slot:button-content>
            <b-list-group style="max-width: 300px;">
              <b-list-group-item class="d-flex align-items-center p-0 border-0">
                <b-avatar
                  v-if="user.PhotoPath"
                  class="mr-3"
                  variant="info"
                  :src="`data:image/jpg;base64,${user.PhotoPath}`"
                ></b-avatar>
                <b-avatar
                  v-else
                  class="mr-3"
                  :text="userAlias"
                  variant="info"
                ></b-avatar>

                <span class="profile-username">
                  {{ userName }}
                  <br />
                  <small>{{ user.JobTitle }}</small>
                </span>
              </b-list-group-item>
            </b-list-group>
          </template>
          <b-dropdown-item href="#" @click="logout">{{
            t.t(dictEnum.BTN_Logout)
          }}</b-dropdown-item>
          <b-dropdown-item href="#" v-b-modal.modal-changePass>
            {{ t.t(dictEnum.BTN_ChangePw) }}
          </b-dropdown-item>
          <b-dropdown-item href="#" v-b-modal.modal-changeLang>
            {{ t.t(dictEnum.LBL_Language) }}
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal
      id="modal-changePass"
      :title="t.t(dictEnum.BTN_ChangePw)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="changePass"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Password) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="oldPass"
                maxlength="10"
                type="password"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_NewPassword) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="newPass"
                maxlength="10"
                type="password"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_ConfirmNewPw) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-group class="font-weight-normal">
              <b-form-input
                v-model="newConfirmPass"
                maxlength="10"
                type="password"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal
      id="modal-changeLang"
      :title="t.t(dictEnum.LBL_Language)"
      :ok-title="t.t(dictEnum.BTN_Submit)"
      :cancel-title="t.t(dictEnum.BTN_Cancel)"
      @ok="changeLang"
    >
      <div class="p-3">
        <b-row class="my-1 no-gutters">
          <b-col sm="5">
            <b-input-group-prepend is-text>
              <span class="bg-white">{{ t.t(dictEnum.LBL_Language) }}</span>
            </b-input-group-prepend>
          </b-col>
          <b-col sm="7">
            <b-form-select
              id="language"
              name="language"
              size="sm"
              v-model="lang"
              :options="langList"
              value-field="value"
              :text-field="user.Lang == 'EN' ? 'EDesc' : 'CDesc'"
              v-validate="'required'"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </nav>
</template>

<script>
import axios from "axios";
import router from "../../router";
import LoginService from "@/service/LoginService";
import HandleErrorService from "@/service/HandleErrorService";
import SweetAlertService from "@/service/SweetAlertService";
import dictEnum from "@/constants/SysMsgDict";
import StoreGetter from "@/constants/StoreGetter";
import $t from "@/service/SysMsgService";

export default {
  name: "HeaderComponent",
  data: function() {
    return {
      t: $t,
      dictEnum: dictEnum,
      oldPass: "",
      newPass: "",
      newConfirmPass: "",
      lang: "",
      langList: [
        { CDesc: "英文", EDesc: "English", value: "EN" },
        { CDesc: "繁體中文", EDesc: "Traditional Chinese", value: "TC" },
        { CDesc: "簡體中文", EDesc: "Simplified Chinese", value: "SC" }
      ]
    };
  },
  components: {},
  methods: {
    logout: function() {
      const compCode = this.$store.getters[StoreGetter.user].CompCode;
      this.$store.dispatch({
        type: `AuthenticationStore/initUser`,
        payload: {}
      });
      this.$router.push(`/login/${compCode}`);
    },
    validatePassword: function() {
      if (!this.oldPass || !this.newPass || !this.newConfirmPass) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_AllPassMustBeEntered)
        );
        return false;
      } else if (this.newPass !== this.newConfirmPass) {
        SweetAlertService.warning(
          "Warn",
          this.t.t(dictEnum.WARN_PasswordNotMatch)
        );
      } else {
        return true;
      }
    },
    changePass: async function() {
      if (this.validatePassword()) {
        const obj = {
          oldPassword: this.oldPass,
          newPassword: this.newPass,
          userId: this.$store.getters[StoreGetter.user].UserID
        };

        const response = await LoginService.resetPassword(obj);
        if (response.data.IsSuccess) {
          SweetAlertService.success("Success", response.data.Message);
          this.oldPass = "";
          this.newPass = "";
          this.newConfirmPass = "";
        } else {
          SweetAlertService.warning("Warn", response.data.Message);
        }
      }
    },

    async changeLang() {
      const obj = {
        StaffID: this.user.UserID,
        Lang: this.lang
      };

      const response = await LoginService.changeLang(obj);
      if (response.data.IsSuccess) {
        this.logout();
        SweetAlertService.success("Success", response.data.Message);
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
    userAlias() {
      let alias = "";
      if (this.user.Lang == "EN") {
        alias = this.user.EngName.charAt(0) + this.user.EngLastName.charAt(0);
      } else {
        alias = this.user.ChiLastName
          ? this.user.ChiLastName
          : this.user.ChiName.charAt(0);
      }
      return alias;
    },
    userName() {
      return this.$store.getters[StoreGetter.user].Lang == "EN"
        ? this.$store.getters[StoreGetter.user].EngName +
            " " +
            this.$store.getters[StoreGetter.user].EngLastName
        : this.$store.getters[StoreGetter.user].ChiLastName +
            this.$store.getters[StoreGetter.user].ChiName;
    },
    menuName() {
      const sysMenu = this.$store.getters[StoreGetter.sysMenu].find(
        x => x.MenuID === this.$route.meta.menuId
      );
      const menuName = sysMenu ? sysMenu.MenuName : "";
      return menuName;
    },
    serverRouter() {
      return this.$store.getters[StoreGetter.serverRouter];
    }
  },
  mounted() {}
};
</script>
<style scoped>
.profile-username {
  color: #9eadb9 !important;
  text-align: left;
}

.input-group-text {
  background: white;
  border: 0;
}

.elms-title {
  font-size: 20px;
  font-weight: bold;
}
.elms-subtitle {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/HeaderComponent.vue